import { put, takeLatest } from 'redux-saga/effects';
import { Notify } from '@flexisaf/flexibull2';
import { TOP_RIGHT, SUCCESS } from 'utils/constants';
import request from 'utils/request';
import urls from 'utils/config';
import {
  deleteInterswitchPaymentConfigSuccess,
  deletePaystackPaymentConfigSuccess,
  deleteRemitaPaymentConfigSuccess,
  deleteSokotoIrsPaymentConfigSuccess,
  deletePaymentConfigFailure,
} from '../actions';
import paymentConfigTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

function* deletePaymentConfig({ payload }) {
  const { paymentConfig, cb } = payload;
  const {  id, schoolConfig: { paymentPlatform } } = paymentConfig;
  const url = `${API_BASE_URL}/paylog-configurations/${paymentConfig.id}`;
  const response = yield request({
    method: 'delete',
    url,
  });

  if (response.success) {
    if (id === 'REMITA') {
      yield put(deleteRemitaPaymentConfigSuccess());
    } else if (id === 'PAYSTACK') {
      yield put(deletePaystackPaymentConfigSuccess());
    } else if (id === 'INTERSWITCH') {
      yield put(deleteInterswitchPaymentConfigSuccess());
    } else if (id === 'SOKOTO_IRS') {
      yield put(deleteSokotoIrsPaymentConfigSuccess());
    }
    cb();
    Notify(`${paymentPlatform?.id} configurations deleted successfully`, {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
  } else {
    yield put(
      deletePaymentConfigFailure(
        'An error occured. Please reload the page to try again.'
      )
    );
      networkErrorHandler(response?.statusCode, response?.message?.string || response?.message);
  }
}

export function* onDeletePaymentConfig() {
  yield takeLatest(
    paymentConfigTypes.DELETE_PAYMENT_CONFIG_REQUEST,
    deletePaymentConfig
  );
}
